import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';

import { Subject } from 'rxjs';

import { AdvertService } from '../../services/advert.service';
import { AdvertQueryResponse, AdvertSearchResult } from '../../models/advert.model';
import { AdvertQuery, SearchTerm, SearchTermTypes } from '../../models/advertQuery.model';
import { ESearchPagination, EAdvancedSearchStatus } from '../../datatypes/misc';
import { Constants } from '../../datatypes/constants';
import { BooleanSubject } from '../../datatypes/misc';
import { SearchFormSharedService } from './searchForm/searchForm.shared.service';
import { PreviousRouteService } from 'src/app/services/previous-route.service';
import { JobAlertService } from '../account/manage/job-alerts/services/job-alert.service';
import { JobAlertCriteria } from '../account/manage/job-alerts/models';
import { ECategoryCriteria } from '../account/manage/job-alerts/enums/ECategoryCriteriaEnum';
import { JbeModalTypes } from './jbe-custom-modal/enums/jbe-modal-types.enum';
import { AppConfig } from 'src/app/app.config';
import { HelpersService } from 'src/app/helpers/helpers.service';
import { Meta, Title } from '@angular/platform-browser';
import { CorporateConfig } from 'src/app/corporate.config';
import { AuthenticationService } from '../../services/authentication.service';
import { Router } from '@angular/router';

@Component({
    selector: 'search-result',
    templateUrl: './search.result.component.html',
    styleUrls: ['./search.result.component.css']
})

export class SearchResultComponent implements OnInit {

    maxLetters = Constants.ViewMaxLettersOfJobDetailsDescription;

    searchResponse = this.searchFormSharedService.getSearchResults();
    NoMorePages = true;
    NoPreviousPages = true;
    appConfig = AppConfig;
    resetSearchForm: BooleanSubject = new Subject();
    previousUrl: string;
    displayBackToJobAlertsLink = false;
    isUserLoggedIn$ = this.authenticationService.isUserLoggedin;
    searchTerms: SearchTerm[];
    criteria: JobAlertCriteria[] = [];

    //mode = AppConfig.getAccountMode;
    //path = AppConfig.clientJobSearchUrl;

    private initQuery = new AdvertQuery;

    private readonly isAccountApplicationMode = AppConfig.getAccountMode;
    private readonly accountModeUrl = AppConfig.getAccountModeUrl;

    @ViewChild('openCreateJbeModalBtn', { static: false }) openCreateJbeModalBtn: ElementRef;
    @ViewChild('openCreateJbeErrorModalBtn', { static: false }) openCreateJbeErrorModalBtn: ElementRef;
    @ViewChild('openCreateJbeConfirmModalBtn', { static: false }) openCreateJbeConfirmModalBtn: ElementRef;
    @ViewChild('openCreateSkeletonJbeModalBtn', { static: false }) openCreateSkeletonJbeModalBtn: ElementRef;
    @ViewChild('openCreateSkeletonJbeConfirmModalBtn', { static: false }) openCreateSkeletonJbeConfirmModalBtn: ElementRef;
    @ViewChild('openMaxReachedModalBtn', { static: false }) openMaxReachedModalBtn: ElementRef;
    @ViewChild('openResendEmailModalBtn', { static: false }) openResendVerificationEmailModalBtn: ElementRef;
    @ViewChild('openCreateAccountModalBtn', { static: false }) openCreateAccountModalBtn: ElementRef;

    constructor(
        public advertService: AdvertService,
        private searchFormSharedService: SearchFormSharedService,
        private previousRouteService: PreviousRouteService,
        private authenticationService: AuthenticationService,
        private jobAlertService: JobAlertService,
        private helperService: HelpersService,
        private title: Title,
        private meta: Meta,
        private router : Router
    ) {
        this.title.setTitle(this.helperService.getPageContent(CorporateConfig.searchTitle));
        this.meta.updateTag({name: 'description', content: this.helperService.getPageContent(CorporateConfig.searchDescription)});
    }


    ngOnInit() {

        //if (this.mode)
        //{
        //    window.location.href = this.path;
        //}

        this.searchTerms = this.searchFormSharedService.getSearchTermValue();
        this.previousUrl = this.previousRouteService.getPreviousUrl();

        if (this.previousUrl.includes('/account/manage')) {
            this.displayBackToJobAlertsLink = true;
        } else {
            this.displayBackToJobAlertsLink = false;
        }
    }

    viewSearchResult(response: AdvertQueryResponse) {
        this.searchResponse = response;
        if (this.searchResponse.Results.length > 0) {
            this.searchTerms = this.searchFormSharedService.getSearchTermValue();
            this.HandleSearchResults(response);
        } else {
            this.HandleZeroResults(response);
        }
    }

    getLocation(advertSearchResult: AdvertSearchResult): string {
        if (advertSearchResult.PostalTown && advertSearchResult.PostalTown.length > 0) {
            return advertSearchResult.PostalTown[0];
        }
        if (advertSearchResult.Locality && advertSearchResult.Locality.length > 0) {
            return advertSearchResult.Locality[0];
        }
        return '';
    }

    SearchUnavailable() {
        return (this.searchResponse.Status === EAdvancedSearchStatus.ServiceUnavailable);
    }

    NextResultPage() {
        const searchParams = this.searchResponse.SearchQuery;
        searchParams.PagingDictionary.PagingParameter = ESearchPagination.NextPage;
        const nextPage = searchParams.PagingDictionary.CurrentPage + 1;
        searchParams.PagingDictionary.RequestedPage = nextPage;
        this.searchFormSharedService.setPagingDictionary(searchParams.PagingDictionary);
        this.doSearch(searchParams);
    }

    PreviousResultPage() {
        const searchParams = this.searchResponse.SearchQuery;
        searchParams.PagingDictionary.PagingParameter = ESearchPagination.PreviousPage;

        // shouldn't need to do this if previous button is disabled correctly !!
        const prevPage = Math.max(searchParams.PagingDictionary.CurrentPage - 1, 1);
        searchParams.PagingDictionary.RequestedPage = prevPage;
        this.searchFormSharedService.setPagingDictionary(searchParams.PagingDictionary);
        this.doSearch(searchParams);
    }

    getAllJobs(): void {
        this.advertService.getAdvertSearch(this.initQuery).subscribe(r => this.viewSearchResult(r));
        this.resetSearchForm.next(true);
    }

    createJobAlert(isLoggedIn: boolean) {
        this.setCriteria();

        if (isLoggedIn) {
            this.jobAlertService.getCount()
                .subscribe(count => {
                    if (count < 5) {
                        this.openNextJbeModal(JbeModalTypes.Create);
                    } else {
                        this.openNextJbeModal(JbeModalTypes.Error);
                    }
                });
        } else {
            this.openNextJbeModal(JbeModalTypes.CreateSkeleton);
        }
    }

    openNextJbeModal(type: JbeModalTypes) {
        switch (type) {
            case JbeModalTypes.Create:
                this.openCreateJbeModalBtn.nativeElement.click();
                break;
            case JbeModalTypes.Confirmation:
                this.openCreateJbeConfirmModalBtn.nativeElement.click();
                break;
            case JbeModalTypes.Error:
                this.openCreateJbeErrorModalBtn.nativeElement.click();
                break;
            case JbeModalTypes.CreateSkeleton:
                this.openCreateSkeletonJbeModalBtn.nativeElement.click();
                break;
            case JbeModalTypes.SkeletonConfirm:
                this.openCreateSkeletonJbeConfirmModalBtn.nativeElement.click();
                break;
            case JbeModalTypes.MaxReached:
                this.openMaxReachedModalBtn.nativeElement.click();
                break;
            case JbeModalTypes.ResendVerificationEmail:
                this.openResendVerificationEmailModalBtn.nativeElement.click();
                break;
            case JbeModalTypes.CreateAccount:
                this.openCreateAccountModalBtn.nativeElement.click();
                break;
            default:
                break;
        }
    }

    getDateE(theDate): string {
        var dDate = new Date(theDate.substring(0, 10));
        return dDate.toString();
    }

    navigateToJobDetails(jobTitle: string, advertId: string) {
        let jobDetailsUrl: string = `/job/${jobTitle}/${advertId}`;
        this.isAccountApplicationMode ?
            document.location.href = this.accountModeUrl + `job/${jobTitle}/${advertId}` :
            this.router.navigate([jobDetailsUrl]);
    }

    private setCriteria() {
        this.criteria = [];

        this.searchTerms.forEach(x => {
            const criteria = new JobAlertCriteria(null, null, null);
            if (x.type === SearchTermTypes.DISTANCE) {
                criteria.Category = ECategoryCriteria.Distance;
                criteria.Title = x.value.toString();
                criteria.Uri = x.value.toString();
                this.criteria.push(criteria);
            } else if (x.type === SearchTermTypes.LOCATION) {
                criteria.Category = ECategoryCriteria.Location;
                criteria.Title = x.value;
                criteria.Uri = JSON.stringify(this.searchFormSharedService.getLocationDataValue());
                this.criteria.push(criteria);
            } else {
                criteria.Category = ECategoryCriteria.Keywords;
                criteria.Title = x.value;
                criteria.Uri = x.value;
                this.criteria.push(criteria);
            }
        });
    }

    private HandleSearchResults(response: AdvertQueryResponse) {
        this.searchResponse.SearchQuery.PagingDictionary.CurrentPage =
            this.searchResponse.SearchQuery.PagingDictionary.RequestedPage;
        this.checkNoPreviousPages();
        this.checkNoNextPages();
    }

    private HandleZeroResults(response: AdvertQueryResponse) {
        this.NoMorePages = true;
        this.checkNoPreviousPages();
        if (response.TotalHits === 0) {
            this.searchResponse.Results = [];
        }
    }

    // check if we're on the first page
    private checkNoPreviousPages() {
        this.NoPreviousPages = (this.searchResponse.SearchQuery.PagingDictionary.CurrentPage === 1);
    }

    private checkNoNextPages() {
        this.NoMorePages = (this.searchResponse.SearchQuery.PagingDictionary.RequestedPage
            === this.searchResponse.SearchQuery.PagingDictionary.MaxNumResultPages);
    }

    private doSearch(advertQuery: AdvertQuery) {
        this.advertService.getAdvertSearch(advertQuery).subscribe(r => this.viewSearchResult(r));
        window.scroll(0, 0);
    }
}
